import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react"; // Icon library
interface AdvisorsProps {
    image?: string;
    name: string;
    position: string;
    context: string;
}
const Advisors: React.FC<AdvisorsProps> = ({ image, name, position, context }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="h-full bg-white border border-[#F8D835] rounded-lg p-4 w-80 mx-auto shadow-2xl">
            <img src={image} alt={image} className="w-full max-w-[280px] aspect-square" />
            {/* Header */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex justify-between items-center w-full"
            >
                <div className="text-left">
                    <h2 className="font-bold text-xl text-black">{name}</h2>
                    <p className="text-[#F8D835] font-semibold text-md">{position}</p>
                </div>
                {isOpen ? <ChevronUp className="text-[#F8D835]" /> : <ChevronDown className="text-[#F8D835]" />}
            </button>

            {/* Content */}
            {isOpen && (
                <div className="mt-3 text-center text-black text-sm">
                    {context}
                </div>
            )}
        </div>
    );
};

export default Advisors;
